import { encode as base64_encode } from "base-64";
import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class PassengerLogReportStore {
  passengerLogReport = [];
  studentsData = []
  total = 0;
  studentDataTotal = 0
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      passengerLogReport: observable,
      total: observable,
      studentDataTotal: observable,
      loading: observable,
      studentsData: observable,

      loadData: action,
      exportExcel: action,
      exportpdf: action,
      exportcsv: action,
      exportxml: action,
      loadStudentsData: action
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, companyId, fromDate, toDate, vehicleId, searchStudent, reportType, pickupFilter }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      PickDrop: pickupFilter,
      limit: limit,
      page: 1,
      searchStudent: searchStudent,
      reportType: reportType,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      // .post("index.php?c=vehicle&a=passengerlog", "postData=" + base64Input);
      .post("index.php?c=passenger&a=passengerLogReport", "postData=" + base64Input);

    this.passengers = response?.data?.data?.reportData;

    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }

  async loadStudentsData({ passengerId, fromDate, toDate, offset, limit }) {
    this.loading = true;
    var postData = {
      passengerId: passengerId,
      fromDate: fromDate,
      toDate: toDate,

      offset: offset,
      limit: limit
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=passenger&a=passLogDetails",
        "postData=" + base64Input
      );

    this.studentsData = response?.data?.data?.reportData;
    this.studentDataTotal = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }

  async exportExcel(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=passenger&a=exportpassengerLogReportExcel&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&searchStudent=" +
      getData.searchStudent +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }

  async exportpdf(getData) {

    window.location.href =
      baseURL +
      "index.php?c=passenger&a=exportpassengerLogReportPdf&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&searchStudent=" +
      getData.searchStudent +
      "&colList=" +
      getData.colList;
  }

  async exportcsv(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportpasslogcsv&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }

  async exportxml(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportpasslogxml&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }



}

export default PassengerLogReportStore;
